// The lockstep sim-behavior version (mpshared/mpht.h:108 knVersionSimulation). Bumped on every
// intentional lockstep-behavior change so old `.wirep` recordings stay faithfully replayable: a
// recording carries the version it was played at, and the sim reproduces THAT version's behavior
// when re-simming it (ctx.simVersion; see tasks/sim-quirks.md "Intentional divergences"). Live
// games run this current value; replays pass their header's simVersion.
//
// Owned by the sim (it's a sim-behavior property); client/src/net/httpservice.ts re-exports it as
// the ?v= / dwVersionSimulation network value. Dependency-free on purpose so lightweight importers
// (the net layer) don't pull in the sim graph.
export const knVersionSimulation = 5;
